<app-header
  canvasMode="error"
  [loggedIn]="true"
  canvasType="canvasType"
  [fixedHeader]="true"
></app-header>
<div class="home-container">
  <BR /><BR />
  <div class="top">500 - SERVER ERROR</div>
  <div class="line"></div>
  <h1>
    <p>500<span>A SERVER ERROR HAS OCCURRED</span></p>
  </h1>
  <div class="bottom">
    YOU MAY HAVE MISTYPED THE ADDRESS OR THE PAGE MAY HAVE MOVED
  </div>
</div>
